module.exports = __webpack_public_path__ + "media/images/autera.claim.logo-fb1d301ccc4b507ff9653bc1dc83fbbc.svg";